import { TFunction } from 'i18next'

import { LanguageResources } from '@/@types/i18next'
import { ApplicationAccountUserRole } from '../models/applicationAccountUser'

export function translateApplicationAccountUserRole(
  t: TFunction<[LanguageResources]>,
  role: ApplicationAccountUserRole,
): string {
  switch (role) {
    case ApplicationAccountUserRole.OWNER:
      return t('common:enums.applicationAccountUserRole.owner')
    case ApplicationAccountUserRole.ADMIN:
      return t('common:enums.applicationAccountUserRole.admin')
    case ApplicationAccountUserRole.MANAGER:
      return t('common:enums.applicationAccountUserRole.manager')
    case ApplicationAccountUserRole.FINANCIAL:
      return t('common:enums.applicationAccountUserRole.financial')
    case ApplicationAccountUserRole.OPERATOR:
      return t('common:enums.applicationAccountUserRole.operator')
    default:
      return role
  }
}
